module.exports = __webpack_public_path__ + "static/media/loader.adfc7800.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/loader.svg
// module id = 532
// module chunks = 0